import { Box, keyframes, styled, useTheme } from '@mui/material';

const rotate = keyframes`
  100% {
    transform: rotate(360deg);
  }
`;

const dash = keyframes`
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -35px;
  }
  100% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -124px;
  }
`;

const StyledSvg = styled('svg')({
  animation: `${rotate} 1.4s linear infinite`,
  transform: 'rotate(-90deg)',
});

const StyledCircle = styled('circle')({
  strokeDasharray: '80px, 200px',
  strokeDashoffset: 0,
  animation: `${dash} 1.4s ease-in-out infinite`,
});

export const GradientCircularProgress = ({ size = 16 }: { size?: number }) => {
  const theme = useTheme();
  const gradientId = 'gradient-circular-progress-unique-id'; // Make ID unique

  return (
    <Box sx={{ position: 'relative', width: size, height: size }}>
      <StyledSvg width={size} height={size} viewBox="22 22 44 44">
        <defs>
          <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor={theme.palette.primary.main} />
            <stop offset="100%" stopColor={theme.palette.secondary.main} />
          </linearGradient>
        </defs>
        <StyledCircle
          cx="44"
          cy="44"
          r="20.2"
          fill="none"
          strokeWidth="3.6"
          stroke={`url(#${gradientId})`}
        />
      </StyledSvg>
    </Box>
  );
};
